<template>
    <div>
      <div class="laypanel" style="margin: 40px;">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="IDFA">
                <el-input v-model="idfa"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left" style="margin-left: 30px;">
              <el-form-item label="广告选择:">
                <el-select v-model="gginfo" filterable clearable placeholder="请选择广告">
                  <el-option
                    v-for="item in gglist"
                    :key="item.APP_ID"
                    :label="item.APP_NAME"
                    :value="item.APP_ID"
                  >
                    <span style="float: left">{{ item.APP_NAME }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.APP_ID }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="queryhd">查看回调</el-button>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="querynewhd">查看新回调</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-table
            stripe
            :data="hddata"
            ref="multipleTable">
            <el-table-column
              prop="IDFA"
              label="IDFA">
            </el-table-column>
            <el-table-column
              prop="PID"
              label="广告标识">
            </el-table-column>
            <el-table-column
              prop="CID"
              label="渠道">
            </el-table-column>
            <el-table-column
              prop="REQUEST_TIME"
              label="回调时间">
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GetHD',
    data () {
      return {
        idfa: '',
        gglist: [],
        gginfo: '',
        hddata: []
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.querygg()
    },
    methods: {
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.gglist = res.data
            } else {
              that.gglist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryhd () {
        var qdata = {
          idfa: that.idfa,
          pid: that.gginfo
        }
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getallhd',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querynewhd () {
        var qdata = {
          idfa: that.idfa,
          pid: that.gginfo
        }
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewallhd',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gg/GetHD.vue